import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";
import {Tag} from "primereact/tag";
import appStore from "../../storage/AppStore";
import clubStore from "../../storage/ClubStore";
import Select from "../../ui/Select";
import Btn from "../../ui/Btn";
import PageLayout from "../PageLayout";

const TeamList = ({role}) => {
    const navigate = useNavigate();

    const search = () => {
        if (role === "TRN") clubStore.getTeamsTrainer();
        else clubStore.getTeams();
    };

    const TeamItem = ({team}) => (
        <div className="grid secondary-card">
            <div className="col-12">
                <div className="flex justify-content-between align-items-start gap-2">
                    <div>
                        <div className="flex align-items-center gap-2">
                            <b className="text-lg">{team.sport?.icon} {team.name}</b>
                        </div>
                        {team.sport?.name && (
                            <div className="mt-2">
                                <Tag value={team.sport.name} severity="info"/>
                            </div>
                        )}
                    </div>
                    {role === "MGR" && (
                        <div className="text-right">
                            <div className="text-500 text-sm">{appStore.tr.fee}</div>
                            <b className="text-lg">
                                {team.fee} {clubStore.club.country.currency_sign}
                            </b>
                        </div>
                    )}
                </div>

                {team.schedule?.length > 0 && (
                    <div className="mt-3">
                        <div className="flex align-items-center mb-2">
                            <i className="pi pi-calendar text-primary mr-2"/>
                            <small className="text-600">{appStore.tr.class_schedule}</small>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {team.schedule.map((day, index) => (
                                <Tag
                                    key={index}
                                    severity="secondary"
                                    value={`${appStore.tr[day.name]}, ${day.time_from}-${day.time_to}`}
                                />
                            ))}
                        </div>
                    </div>
                )}

                <div className="flex mt-3">
                    {role === "MGR" && (
                        <>
                            <Btn
                                icon="pi pi-eye"
                                className="mr-2"
                                outlined
                                severity="success"
                                tooltip={appStore.tr.show}
                                onClick={() => navigate(`/manager/team/show/${team.id}`)}
                            />
                            <Btn
                                icon="pi pi-pencil"
                                outlined
                                severity="primary"
                                tooltip={appStore.tr.edit}
                                onClick={() => navigate(`/manager/team/edit/${team.id}`)}
                            />
                        </>
                    )}
                    {role === "TRN" && (
                        <Btn
                            icon="pi pi-chart-line"
                            outlined
                            severity="info"
                            label={appStore.tr.attendance}
                            onClick={() => navigate("/trainer/trainings")}
                        />
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <PageLayout
            header={
                <div className="flex justify-content-between align-items-center w-full">
                    <h3 className="m-0">{appStore.tr.teams} ({clubStore.teams.length})</h3>
                    {role === "MGR" && (
                        <Btn
                            icon="pi pi-plus"
                            severity="success"
                            label={appStore.tr.add}
                            onClick={() => navigate("/manager/team/new")}
                        />
                    )}
                </div>
            }
            filters={
                <div className="grid align-items-center">
                    <div className="col-10 md:col-5">
                        <Select
                            store={clubStore.teamQuery}
                            prop="company_id"
                            style={{height: '40px'}}
                            label={appStore.tr.club_branch}
                            options={clubStore.club.relatives}
                            for_search
                        />
                    </div>
                    <div className="col-2 md:col-1">
                        <Btn icon="pi pi-search"
                             severity="info"
                             className="w-full"
                             style={{height: '40px'}}
                             label={appStore.tr.search}
                             onClick={search}/>
                    </div>
                </div>
            }
        >
            {clubStore.teams.length === 0 && (
                <div className="flex py-4 justify-content-center text-600">
                    {appStore.tr.not_found}
                </div>
            )}
            {clubStore.teams.map((team) => <TeamItem key={team.id} team={team}/>)}
        </PageLayout>
    );
};

export default observer(TeamList);